import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getAccountTransactionTypeList,
  getAccountTransactionTypeById,
  createAccountTransactionType,
  updateAccountTransactionType,
  deleteAccountTransactionType,
} from "api/accountTransactionTypeApi"

export const ACCOUNT_TRANSACTION_TYPE_QUERY_KEY = "account-transaction-type"

export const useAccountTransactionTypes = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_TRANSACTION_TYPE_QUERY_KEY,
    getAccountTransactionTypeList,
    params,
    enabled
  )
}

export const useAccountTransactionType = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_TRANSACTION_TYPE_QUERY_KEY,
    getAccountTransactionTypeById,
    id,
    enabled
  )
}

export const useCreateAccountTransactionType = () => {
  return useCreateResource(
    createAccountTransactionType,
    ACCOUNT_TRANSACTION_TYPE_QUERY_KEY
  )
}

export const useEditAccountTransactionType = () => {
  return useEditResource(
    updateAccountTransactionType,
    ACCOUNT_TRANSACTION_TYPE_QUERY_KEY
  )
}

export const useDeleteAccountTransactionType = () => {
  return useDeleteResource(
    deleteAccountTransactionType,
    ACCOUNT_TRANSACTION_TYPE_QUERY_KEY
  )
}
